import React from "react";
import { Row, Col } from "react-bootstrap";
import { MDBInput, MDBBtn, MDBCard, MDBCardBody } from "mdb-react-ui-kit";
import { motion } from "framer-motion";

const InputForm = ({ formData, setFormData, handleSubmit }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { name, value, checked } = e.target;
    const updatedArray = checked
      ? [...(formData[name] || []), value]
      : (formData[name] || []).filter((item) => item !== value);
    setFormData({ ...formData, [name]: updatedArray });
  };

  const renderCheckboxGroup = (name, options) => (
    <div className="mb-3">
      {options.map((option) => (
        <div key={option} className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            name={name}
            value={option}
            id={`${name}-${option}`}
            checked={formData[name]?.includes(option)}
            onChange={handleCheckboxChange}
          />
          <label className="form-check-label" htmlFor={`${name}-${option}`}>
            {option}
          </label>
        </div>
      ))}
    </div>
  );

  const renderInput = (label, name, type = "text") => (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <MDBInput
        label={label}
        id={name}
        name={name}
        type={type}
        value={formData[name] || ""}
        onChange={handleInputChange}
        className="mb-4 shadow-2"
      />
    </motion.div>
  );

  const renderTextarea = (label, name) => (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <MDBInput
        label={label}
        id={name}
        name={name}
        type="textarea"
        value={formData[name] || ""}
        onChange={handleInputChange}
        rows={3}
        className="mb-4 shadow-2"
      />
    </motion.div>
  );

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <MDBCard className="rounded-5 shadow-4 py-4">
        <MDBCardBody>
          <form onSubmit={handleSubmit}>
            <h5 className="mb-4">🔖 Campaign / Client Info</h5>
            {renderInput("Company Name", "companyName")}
            {renderInput("Product/Service Name", "productName")}
            {renderInput("Website", "website")}
            {renderInput("Instagram", "instagram")}
            {renderInput("TikTok", "tiktok")}
            {renderInput("Facebook", "facebook")}
            {renderTextarea("Product Description", "description")}
            {renderInput("Campaign Duration", "duration")}
            {renderInput("Number of Influencers", "influencers")}
            {renderInput("Number of Videos", "videos")}

            <h5 className="mt-5 mb-3">🎯 Campaign Objectives</h5>
            {renderCheckboxGroup("objectives", [
              "Brand Awareness",
              "Lead Generation",
              "Sales / Conversions",
              "App Downloads",
              "Others",
            ])}
            {renderInput("Custom Objective", "customObjective")}

            <h5 className="mt-5 mb-3">👥 Target Audience</h5>
            {renderInput("Age Group", "ageGroup")}
            {renderCheckboxGroup("genderPreference", ["Male", "Female", "NONE"])}
            {renderTextarea("Audience Details", "audienceDetails")}

            <h5 className="mt-5 mb-3">💬 Marketing Message</h5>
            {renderTextarea("Marketing Summary", "marketingSummary")}
            {renderInput("Main Campaign Focus", "mainFocus")}
            {renderCheckboxGroup("platformFocus", [
              "TikTok",
              "Instagram",
              "YouTube",
              "Facebook",
              "Others",
            ])}

            <h5 className="mt-5 mb-3">🛍️ Offer / Promotion</h5>
            {renderTextarea("Offer or Promotion", "offerPromotion")}

            <h5 className="mt-5 mb-3">💰 Price Point</h5>
            {renderInput("Price Point", "pricePoint")}

            <h5 className="mt-5 mb-3">📣 Call-To-Action (CTA)</h5>
            {renderInput("CTA Destination", "ctaDestination")}
            {renderTextarea("Viewer Action", "ctaAction")}

            <h5 className="mt-5 mb-3">📝 Special Requirements</h5>
            {renderTextarea("Must-show Features or Visuals", "specialNotes")}
            {renderInput("Tone of the Video", "tone")}
            {renderTextarea("Additional Notes", "additionalNotes")}

            <motion.div whileHover={{ scale: 1.02 }} className="mt-4">
              <MDBBtn type="submit" className="w-100 py-3 rounded-pill shadow-3">
                🚀 Generate Brief
              </MDBBtn>
            </motion.div>
          </form>
        </MDBCardBody>
      </MDBCard>
    </motion.div>
  );
};

export default InputForm;